import classNames from "classnames";
import AccordionItem from "pages/_components/Accordion/AccordionItem";
import Box from "pages/_components/Box";
import { bool, node, string, func, number } from "prop-types";
import React, { Component } from "react";

export const AccordionContext = React.createContext();

class Accordion extends Component {
    static propTypes = {
        accordionBorderRadius: string,
        children: node.isRequired,
        className: string,
        grayBox: bool,
        whiteBox: bool,
        simpleStyle: bool,
        noMargin: bool,
        customHandlerClick: func,
        defaultOpenItem: number,
        gap: string,
        display: string,
        column: bool,
        gapX: string,
        gapY: string,
        additionalHandleClick: func,
    };

    static defaultProps = {
        accordionBorderRadius: "md",
        className: "navigational-list",
        grayBox: false,
        whiteBox: false,
        simpleStyle: false,
        noMargin: false,
        customHandlerClick: null,
        defaultOpenItem: null,
        gap: null,
        display: null,
        column: false,
        gapX: null,
        gapY: null,
        additionalHandleClick: null,
    };

    state = {
        itemOpen: this.props.defaultOpenItem,
    };

    validateActive = (isActive) => {
        const { customHandlerClick } = this.props;
        if (customHandlerClick) {
            customHandlerClick(isActive);
        }
    };

    handleClick = (num) => {
        const { additionalHandleClick } = this.props;
        const { itemOpen } = this.state;
        if (num === itemOpen) {
            this.setState({ itemOpen: null });
        } else {
            this.setState({ itemOpen: num });
        }
        if (additionalHandleClick) {
            additionalHandleClick();
        }
    };

    static Item = AccordionItem;

    render() {
        const {
            className,
            children,
            grayBox,
            whiteBox,
            simpleStyle,
            noMargin,
            accordionBorderRadius,
            gap,
            gapX,
            gapY,
            display,
            column,
        } = this.props;
        const { itemOpen } = this.state;

        return (
            <AccordionContext.Provider
                value={{ itemOpen, onClick: this.handleClick, validateActive: this.validateActive }}>
                <Box
                    component="ul"
                    overflow="hidden"
                    borderRadius={accordionBorderRadius}
                    {...(gap && { gap })}
                    {...(display && { display })}
                    {...(column && { column: true })}
                    className={classNames(className, {
                        "accordion-boxed accordion-gray-boxed": grayBox,
                        "accordion-boxed accordion-white-boxed": whiteBox,
                        "simple-style": simpleStyle,
                        "m-0": noMargin,
                        [`gapX-${gapX}`]: gapX,
                        [`gapY-${gapY}`]: gapY,
                    })}>
                    {children}
                </Box>
            </AccordionContext.Provider>
        );
    }
}

export default Accordion;
